import {motion as m} from 'framer-motion';
import ScrollToTop from '../../components/ScrollToTop';
import {useEffect} from 'react';
import PageHeaderImage from '../../images/pageheader.jpg';
import PageHeader from '../../components/PageHeader';
import {Link} from 'react-router-dom';
import SafeImage from '../../images//homepage-header/Vallan-pest-control.png';
import WhyUs from '../../components/WhyUs';
import ContactCta from '../../components/ContactCta';
import FAQS from '../../components/FAQS';
import './fumigationServices.css';

const FumigationServices = () => {
    return (
        <m.div 
            initial={{x: "-100%"}}
            animate={{x: "-0%"}}
            transition={{ duration: 0.9, delay:0.7}}
            exit={{opacity: 1}}
        >
            <ScrollToTop />
            <PageHeader title="Fumigation Services" image={PageHeaderImage}>
                <p>
                    <Link to="/">Home</Link> / <Link to="/services">Services</Link> / Fumigation Services
                </p>
            </PageHeader>
            <section className='services'>

                <div className="fumigation-services">
                    <div className="container fumigation-services-content-container">
                        <div className="fumigation-services-content">
                            <h1>
                                Fumigation Services
                            </h1>
                            <br />
                            <p>
                                When it comes to pest control, one of the most effective methods is fumigation. This process involves
                                the use of a pesticide in a gaseous form to kill pests in an enclosed space. Fumigation is an essential part
                                of pest control, as it can help eliminate even the most stubborn pests that are difficult to control using
                                other methods.
                            </p>
                            <p>
                                At PestEX Masters, we provide professional fumigation services that are designed to effectively
                                eliminate a wide range of pests, including cockroaches, bed bugs, fleas, termites, and more. Our
                                fumigation services are designed to provide a comprehensive solution to your pest problem, and we use
                                only the most effective and safe pesticides to ensure the best results.
                            </p>
                            <p>
                                Our team of highly trained and experienced technicians use state-of-the-art equipment and techniques
                                to ensure that the fumigation process is carried out safely and efficiently. We take every precaution to
                                protect your property and ensure that the fumigation process is carried out in a way that minimizes any
                                potential harm to humans or pets.
                            </p>
                            <p>
                                When you choose PestEX Masters for your fumigation needs, you can rest assured that you are getting
                                the best possible service at an affordable price. We are committed to providing our customers with the
                                highest level of service and satisfaction, and we always stand behind our work.
                            </p>
                            <p>
                                If you have a pest problem that requires fumigation, don&#39;t wait any longer. Contact PestEX Masters
                                today to schedule a consultation and learn more about our professional fumigation services. We are the
                                experts in pest control in Kenya, and we are here to help you get rid of pests once and for all.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container fumigation-services-saftey-cont">
                    <div className='saftey'>
                        <div className="container saftey_container">
                            <div className="saftey_header">
                                <h1>We use safe and environmentally friendly measures.</h1>
                                <p>Want to create a pest-free environment without compromising your commitment to sustainability? Our environmentally friendly pest control products are the solution.</p>
                            </div>
                            <div className="saftery_image">
                                <img src={SafeImage} alt="" />
                            </div>
                        </div>
                    </div>
                    {/* <HomeServices /> */}
                    <WhyUs />
                    <ContactCta />
                    <FAQS />
                </div>
            </section>
        </m.div>
    )
}

export default FumigationServices